import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      margin: '0px auto',
      height: "calc(100% - 16%)",
      width: "100%",
      // height: '639px',
      // minWidth: '852px',
      maxHeight: '659px',
    },
    headerModal: {
      padding: '16px 24px 11px',
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: '0px 0px 8px 8px',
      height: '16%',
      zIndex: 2,
      position: "sticky",
      top: 0,
      backgroundColor: "#FFF"
    },
    fixedHeightList: {
      height: "700px"
    },
    titleModal: {
      font: theme.custom.font.montserrat16,
      '& p:first-child': {
        font: 'normal normal 700 18px/32px Public-Sans',
        color: theme.custom.colors.primary,
      },
      '& p': {
        color: theme.custom.colors.primary,
      }
    },
    dFlexRight: {
      display: 'flex',
      alignItems: 'center',
      // marginTop: 15
    },
    btnAddRecipeHeader: {
      color: theme.custom.colors.purple,
      font: 'normal normal 700 14px/18px Montserrat',
      cursor: 'pointer'
    },
    wrapSearch: {
      display: 'flex',
      border: `1px solid ${theme.custom.colors.borderGrey}`,
      borderRadius: '30px',
      height: 32,
      width: 260,
      maxWidth: '100%',
      paddingLeft: 10,
      alignItems: 'center',
      marginLeft: 16,
      '& span': {
        display: 'inline-block',
        cursor: 'pointer',
        width: 30,
        textAlign: 'center',
        paddingTop: 4,
      },
      '& input': {
        border: 'none',
        font: theme.custom.font.text12,
        height: 30,
        borderRadius: '30px',
        flex: 1,
        padding: '0 20px 0 5px',
        '&:focus': {
          outline: 'none'
        }
      }
    },
    bodyModal: {
      padding: '24px 47px',
      height: '84%',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    bodyModalList: {
      overflowY: 'auto',
      padding: '24px 47px',
      // padding: '24px 71px 24px 47px',
    },
    noRecipe: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      font: theme.custom.font.montserrat16,
      '& img': {
        marginBottom: 24
      },
      '& p': {
        color: theme.custom.colors.primary,
      }
    },
    btnAddRecipeBody: {
      marginTop: 16,
      '& button': {
        height: 32,
        background: theme.custom.colors.primary,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.title,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    listRecipes: {
      display: 'grid',
      gridRowGap: 24,
      gridTemplateColumns: 'repeat(2, 50%)',
    },
    itemRecipe: {
      display: 'flex',
      border: `1px solid ${theme.custom.colors.borderGrey}`,
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      borderRadius: 10,
      cursor: 'pointer',
      height: 88,
      marginTop: '-1px',
      marginRight: 24,
      '&:nth-child(2n)': {
        marginRight: 0,
      },
      "&:hover, &.active": {
        border: `1px solid ${theme.custom.colors.purp}`
      }
    },
    imgRecipe: {
      minWidth: 116,
      height: 86,
      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: '10px 0 0 10px',
        objectFit: 'cover',
      }
    },
    contentRecipe: {
      minWidth: 'calc(100% - 116px)',
      padding: '12px 17px',
      font: theme.custom.font.montserrat14,
      color: theme.custom.colors.midGray,
    },
    titleRecipe: {
      font: theme.custom.font.montserrat16,
      color: theme.custom.colors.primary,
      maxWidth: '400px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    descriptionRecipe: {
      maxWidth: '400px',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      wordWrap: 'break-word',
      textOverflow: 'ellipsis',
    },
    footerModal: {
      height: '12.4%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
      '& div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
        color: theme.custom.colors.primary,
      }
    },
    listActionMore: {
      width: 195,
      color: theme.custom.colors.primary,
      fontWeight: 500,
    },
    itemActionMore: {
      padding: '8px 23px 8px 17px',
      cursor: 'pointer',
      '&:last-child': {
        color: theme.custom.colors.error,
        borderTop: `1px solid ${theme.custom.colors.borderGrey}`
      }
    },
    styleLoadingPage: {
      width: '100%',
      height: 'calc(100vh - 250px)',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    logoIconLoadmore: {
      width: 24,
      height: 24,
      objectFit: 'contain',
      animation: '$spin 2s linear infinite',
      '& img': {
        width: 24,
        height: 24,
      },
    },
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },
    viewIconLoadmore: {
      width: '100%',
      marginTop: '20px',
      justifyContent: 'center',
      display: 'flex',
    },
  };
});

export default useStyles;
